<script setup>
import { reactive } from 'vue';
import { Head } from '@inertiajs/vue3';
import { storeToRefs } from 'pinia';
import { useOptionsStore } from '@/stores/options';

const { storageOptions } = storeToRefs(useOptionsStore());

const stockFilters = reactive({
    storage: null,
    season: null,
});

const requestFilters = reactive({
    from: null,
    to: null,
    type: null,
    status: null,
});

const download = (path, filters) => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value) {
            params.set(key, value);
        }
    });
    const query = params.toString();
    window.location.href = query ? `${path}?${query}` : path;
};
</script>

<template>
<MainContentLayout>
    <Head :title="$t('label.reports')" />

    <template #title>{{ $t('label.reports') }}</template>

    <div class="grid lg:grid-cols-2 gap-6">
        <div class="rounded-xl border border-line bg-surface p-5">
            <h3 class="font-display font-semibold text-base mb-1">{{ $t('label.stock_report') }}</h3>
            <p class="text-sm text-ink-light mb-4">{{ $t('label.stock_report_hint') }}</p>
            <div class="grid sm:grid-cols-2 gap-x-3">
                <StyledDropdown
                    v-model="stockFilters.storage"
                    clearable
                    :placeholder="$t('label.storage')"
                    :options="storageOptions"
                    name="storage" />
                <StyledDropdown
                    v-model="stockFilters.season"
                    clearable
                    :placeholder="$t('label.season')"
                    :options="[
                        { label: $t('label.winter'), value: 'winter' },
                        { label: $t('label.summer'), value: 'summer' },
                        { label: $t('label.all_season'), value: 'all_season' },
                    ]"
                    name="season" />
            </div>
            <StyledButton @click="download('/reports/stock.csv', stockFilters)">
                <FontAwesomeIcon
                    icon="download"
                    class="mr-1" />
                {{ $t('label.download_csv') }}
            </StyledButton>
        </div>

        <div class="rounded-xl border border-line bg-surface p-5">
            <h3 class="font-display font-semibold text-base mb-1">{{ $t('label.requests_report') }}</h3>
            <p class="text-sm text-ink-light mb-4">{{ $t('label.requests_report_hint') }}</p>
            <div class="grid sm:grid-cols-2 gap-x-3">
                <StyledInput
                    v-model="requestFilters.from"
                    name="from"
                    type="date"
                    :label="$t('label.from_date')" />
                <StyledInput
                    v-model="requestFilters.to"
                    name="to"
                    type="date"
                    :label="$t('label.to_date')" />
                <StyledDropdown
                    v-model="requestFilters.type"
                    clearable
                    :placeholder="$t('label.type')"
                    :options="[
                        { label: $t('label.to_storage'), value: 'to_storage' },
                        { label: $t('label.from_storage'), value: 'from_storage' },
                    ]"
                    name="type" />
                <StyledDropdown
                    v-model="requestFilters.status"
                    clearable
                    :placeholder="$t('label.status')"
                    :options="[
                        { label: $t('label.open'), value: 'open' },
                        { label: $t('label.completed'), value: 'completed' },
                        { label: $t('label.cancelled'), value: 'cancelled' },
                    ]"
                    name="status" />
            </div>
            <StyledButton @click="download('/reports/requests.csv', requestFilters)">
                <FontAwesomeIcon
                    icon="download"
                    class="mr-1" />
                {{ $t('label.download_csv') }}
            </StyledButton>
        </div>
    </div>
</MainContentLayout>
</template>
